import addBusinessDays from 'date-fns/addBusinessDays';
import Swiper, {A11y, Navigation, Pagination, Scrollbar} from 'swiper';
import TinyDatePicker from 'tiny-date-picker/dist/tiny-date-picker.min';

import onboardingEmailTemplate from '../../email/templates/onboarding';
import onboardingManualEmailTemplate from '../../email/templates/onboarding-manual';
import {EmailService} from '../../email/email.service';
import {FilterTable} from '../../components/FilterTable';
import {Formatter} from '../../tools/formatter/formatter.class';
import {Forms} from '../../tools/forms/forms.class';
import {formTemplate} from './formTemplate';
import {gaLegacyCustomEvent} from '../../ga/ga-legacy.functions';
import {ImpError} from '../../imp-error/imp-error.class';
import {PopUpComponent} from '../../ui/pop-up/pop-up.component';
import {ProgressOverlay} from '../../components/ProgressOverlay';
import {RecaptchaComponent} from '../../recaptcha/recaptcha.component';
import {SendEmailParams} from '../../../shared/email/email.class';
import {SortTable} from '../../components/SortTable';
import {UsersService} from '../../users/users.service';

require('./cms-content.component.scss');
require('../../items/item-spinner/item-spinner.component.scss');
require('../../vendor/jquery.validate/jquery.validate.min.js');

export class CmsContentComponent {
    public calendarIcon: JQuery;
    public cmsPrivacyContent: JQuery;
    public cmsTermsAccessContent: JQuery;
    public cmsTermsContent: JQuery;
    public component: JQuery;
    public componentName = `default-cms-content`;
    public dataPicker: JQuery;
    public emailForm: JQuery;
    public emailFormData: JQuery;
    public error: JQuery;
    public errorMessage: JQuery;
    public impSpinner: JQuery;
    public impSpinnerSize: JQuery;
    public phoneInput: JQuery;
    public scheduleOnsiteEval: JQuery;
    public showDatePicker: JQuery;
    public spinners: JQuery;
    public success: JQuery;
    public table: JQuery;
    public termsDetails: JQuery;
    public toggleQuestion: JQuery;
    public viewPrivacyPolicy: JQuery;
    public viewTermsAccess: JQuery;
    public viewTermsSale: JQuery;
    private _disableRecaptcha: boolean;
    private _recaptchaComponent: RecaptchaComponent;

    constructor(
        private _emailService: EmailService,
        private _usersService: UsersService,
    ) {
        this.component = $(`[data-component='${this.componentName}']`);
        this._onInit();
    }

    private _onInit() {
        this._performElementBinding();
        this._registerEventHandlers();
        this._getServerTemplateData();

        // Initialize emailForm handling
        if (this.emailForm && this.emailForm.length > 0) {
            this._initRecaptcha();
            this._initValidationWebForm();
        }

        if (this.table && this.table.length > 0) {
            new FilterTable(`tableSortSearch`, `cmsTableSearch`);
            new SortTable(`tableSortSearch`);
        }

        if (this.impSpinner && this.impSpinner.length > 0) {
            this.impSpinner.each((i, spinner) => {
                let items = 3;
                if ($(spinner).attr(`data-spinner-size`) === `lg`) {
                    items = 1;
                }
                new Swiper(`.swiper`, {
                    modules: [Navigation, Pagination, Scrollbar, A11y],
                    spaceBetween: 10,
                    watchSlidesProgress: true,
                    breakpoints: {
                        0: {
                            slidesPerView: 1,
                            slidesPerGroup: 1,
                        },
                        540: {
                            slidesPerView: items === 3 ? 2 : 1,
                            spaceBetween: items === 3 ? 20 : 0,
                            slidesPerGroup: items === 3 ? 2 : 1,
                        },
                        900: {
                            slidesPerView: items,
                            spaceBetween: 20,
                            slidesPerGroup: items,
                        },
                    },
                    navigation: {
                        nextEl: `.swiper-button-next`,
                        prevEl: `.swiper-button-prev`,
                    },
                    on: {
                        slideNextTransitionEnd: () => {
                            gaLegacyCustomEvent({
                                eventAction: `Next Click`,
                                eventCategory: `WonderSpinner Navigation`,
                                eventLabel: window.location.href,
                            });
                        },
                        slidePrevTransitionEnd: () => {
                            gaLegacyCustomEvent({
                                eventAction: `Previous Click`,
                                eventCategory: `WonderSpinner Navigation`,
                                eventLabel: window.location.href,
                            });
                        },
                    },
                });
            });
        }
    }

    /**
     * Displays CmsPrivacyPopup
     * @param eventObject
     */
    public showCmsPrivacyPopup(eventObject: JQueryMouseEventObject) {
        const component: CmsContentComponent = eventObject.data.component;
        const popUp = new PopUpComponent({
            closeIcon: true,
            componentAlias: `cmsPrivacyPopup`,
            footer: false,
            header: true,
            title: `Privacy Policy`,
        });
        popUp.$content.html(component.cmsPrivacyContent.html());
    }

    /**
     * Displays CmsTermsOfAccessPopup
     * @param eventObject
     */
    public showCmsTermsOfAccessPopup(eventObject: JQueryMouseEventObject) {
        const component: CmsContentComponent = eventObject.data.component;
        const popUp = new PopUpComponent({
            closeIcon: true,
            componentAlias: `cmsTermsOfAccessPopup`,
            footer: false,
            header: true,
            title: `Terms of Access`,
        });
        popUp.$content.html(component.cmsTermsAccessContent.html());
    }

    /**
     * Displays CmsTermsOfSalePopup
     * @param eventObject
     */
    public showCmsTermsOfSalePopup(eventObject: JQueryMouseEventObject) {
        const component: CmsContentComponent = eventObject.data.component;
        const popUp = new PopUpComponent({
            closeIcon: true,
            componentAlias: `cmsTermsOfSalePopup`,
            footer: false,
            header: true,
            title: `Terms of Sale`,
        });
        popUp.$content.html(component.cmsTermsContent.html());
    }

    /**
     * Submits the web login request
     */
    public submitWebForm() {
        ProgressOverlay.activate();
        this._hideError();
        if (this.emailFormData.valid()) {
            const sendEmailParams: SendEmailParams = Forms.convertSerializedArrayToObject(this.emailFormData.serializeArray());
            // For onboarding sliceType, submit to onboarding to API
            if (sendEmailParams.sliceType === `onboarding`) {
                sendEmailParams.body = onboardingEmailTemplate(sendEmailParams);
                this._usersService
                    .onboardUser(sendEmailParams)
                    .then(() => {
                        gaLegacyCustomEvent({
                            eventAction: `Form Submit Success`,
                            eventCategory: `${sendEmailParams.ga_category}` as any,
                            eventLabel: sendEmailParams.ga_label,
                        });
                        ProgressOverlay.deactivate();
                        this.emailFormData.addClass(`d-none`);
                        this.success.find(`span`).text(`An email to verify your account has been sent to ${sendEmailParams.email}`);
                        this.success.removeClass(`d-none`);
                        document.getElementById(`alert`)?.scrollIntoView({
                            behavior: `smooth`,
                        });
                    })
                    .catch((sendEmailErr: ImpError) => {
                        this._recaptchaComponent.reset();
                        gaLegacyCustomEvent({
                            eventAction: `Form Submit Error`,
                            eventCategory: `${sendEmailParams.ga_category}` as any,
                            eventLabel: sendEmailParams.ga_label,
                        });
                        ProgressOverlay.deactivate();
                        this._showError(sendEmailErr.message);
                        window.scrollTo(0, 0);
                    });
            } else {
                // Assign email body based on sliceType
                if (sendEmailParams.sliceType === `customer_onboarding_form_-_manual`) {
                    sendEmailParams.body = onboardingManualEmailTemplate(sendEmailParams);
                } else {
                    sendEmailParams.body = formTemplate(this.emailFormData.serializeArray());
                }

                // Send email with form information
                this._emailService
                    .sendEmail(sendEmailParams)
                    .then(() => {
                        gaLegacyCustomEvent({
                            eventAction: `Form Submit Success`,
                            eventCategory: `${sendEmailParams.ga_category}` as any,
                            eventLabel: sendEmailParams.ga_label,
                        });
                        ProgressOverlay.deactivate();
                        this.emailFormData.addClass(`d-none`);
                        this.success.removeClass(`d-none`);
                        document.getElementById(`alert`)?.scrollIntoView({
                            behavior: `smooth`,
                        });
                    })
                    .catch((sendEmailErr: ImpError) => {
                        this._recaptchaComponent.reset();
                        gaLegacyCustomEvent({
                            eventAction: `Form Submit Error`,
                            eventCategory: `${sendEmailParams.ga_category}` as any,
                            eventLabel: sendEmailParams.ga_label,
                        });
                        ProgressOverlay.deactivate();
                        this._showError(sendEmailErr.message);
                        document.getElementById(`alert`)?.scrollIntoView({
                            behavior: `smooth`,
                        });
                    });
            }
        }
    }

    /**
     * Retrieve data from the server template
     * @private
     */
    private _getServerTemplateData() {
        this._disableRecaptcha = document.getElementById(`cmsContentComponent__disableRecaptcha`).innerHTML === `true`;
    }

    /**
     * Initializes RecaptchaComponent
     * @private
     */
    private _initRecaptcha() {
        this._recaptchaComponent = new RecaptchaComponent(this._disableRecaptcha, this.submitWebForm.bind(this));
    }

    /**
     * Initializes TinyDatePicker
     * @private
     */
    private _initTinyDatePicker() {
        TinyDatePicker(`#datePicker`, {
            mode: `dp-below`,
            min: addBusinessDays(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()), 10),
        });

        $(`#datePicker`).on(`change`, () => {
            this.emailFormData.validate().element(`#datePicker`);
        });
    }

    /**
     * Initializes jquery.validate on webForm
     * @private
     */
    private _initValidationWebForm() {
        $(`input[required]:not([type="checkbox"]), textarea[required], select[required]`).after(
            `<i class='fa fa-exclamation-circle-solid fa-lg error'></i>`,
        );
        this.emailFormData.validate({
            ignore: `:hidden`,
            errorPlacement(error, element) {
                const isAgreeCustomerTermsCheckbox = element.attr(`name`) === `formFields[agreeCustomerTerms]`;
                if (isAgreeCustomerTermsCheckbox) {
                    error.insertBefore(element);
                } else {
                    element.parent().find(`i.action`).addClass(`errorState`);
                    error.insertAfter(element.next().next().next(`label`));
                }
            },
            rules: {
                datePicker: {
                    required: {scheduleOnsiteEval: `yes`},
                },
            },
            invalidHandler: () => {
                this._recaptchaComponent.reset();
            },
            submitHandler: () => {
                this._recaptchaComponent.execute();
            },
            messages: {
                [`formFields[agreeCustomerTerms]`]: `Agreeing to the terms below is required`,
            },
        });
    }

    /**
     * Binds component properties to jQuery selectors
     * @private
     */
    private _performElementBinding() {
        this.calendarIcon = this.component.find(`[data-binding='calendarIcon']`);
        this.emailForm = this.component.find(`[data-binding='default-form-component']`);
        this.error = this.component.find(`[data-binding='email-error']`);
        this.errorMessage = this.component.find(`[data-binding='error-message']`);
        this.impSpinner = this.component.find(`[data-binding='imp-spinner']`);
        this.impSpinnerSize = this.component.find(`[data-spinner-size]`);
        this.success = this.component.find(`[data-binding='email-success']`);
        this.table = this.component.find(`#tableSortSearch`);
        this.termsDetails = this.component.find(`[data-binding='termsDetails']`);
        this.viewTermsSale = this.component.find(`[data-binding='viewTermsSale']`);
        this.viewTermsAccess = this.component.find(`[data-binding='viewTermsAccess']`);
        this.viewPrivacyPolicy = this.component.find(`[data-binding='viewPrivacyPolicy']`);
        this.cmsTermsAccessContent = this.component.find(`[data-binding='cmsTermsAccessContent']`);
        this.cmsPrivacyContent = this.component.find(`[data-binding='cmsPrivacyContent']`);
        this.cmsTermsContent = this.component.find(`[data-binding='cmsTermsContent']`);
        this.phoneInput = this.component.find(`#phone`);
        this.scheduleOnsiteEval = this.component.find(`#scheduleOnsiteEval`);
        this.showDatePicker = this.component.find(`#showDatePicker`);
        this.dataPicker = $(`#datePicker`);
        if (this.emailForm) {
            this.emailFormData = this.component.find(`[data-binding='emailFormData']`);
        }
        this.spinners = this.component.find(`[data-binding^="categorySpinner-"]`);
        this.toggleQuestion = this.component.find(`[data-binding='toggleQuestion']`);
    }

    /**
     * Registers event handlers on component properties
     * @private
     */
    private _registerEventHandlers() {
        if (this.viewTermsSale) {
            this.viewTermsSale.on(`click`, {component: this}, this.showCmsTermsOfSalePopup);
        }
        if (this.viewTermsAccess) {
            this.viewTermsAccess.on(`click`, {component: this}, this.showCmsTermsOfAccessPopup);
        }
        if (this.viewPrivacyPolicy) {
            this.viewPrivacyPolicy.on(`click`, {component: this}, this.showCmsPrivacyPopup);
        }

        if (this.phoneInput) {
            this.phoneInput.on(`input`, Formatter.phoneNumber);
        }

        if (this.scheduleOnsiteEval) {
            this.scheduleOnsiteEval.on(`change`, () => {
                if (this.scheduleOnsiteEval.val() === `yes`) {
                    this.showDatePicker.show();
                    this._initTinyDatePicker();
                    this.calendarIcon.on(`click`, () => {
                        this.dataPicker.focus();
                    });
                } else {
                    this.showDatePicker.hide();
                }
            });
        }
        if (this.toggleQuestion) {
            this.toggleQuestion.on(`click`, (e) => {
                const getContainer =
                    $(e.target).parents(`[data-binding="toggleQuestion"]`).length > 0
                        ? $(e.target).parents(`[data-binding="toggleQuestion"]`)
                        : $(e.target);

                $(getContainer).next(`[data-binding="question"]`).toggle();
                if ($(getContainer).next(`[data-binding="question"]`).is(`:visible`)) {
                    $(getContainer).find(`.fa`).addClass(`fa-angle-up`);
                } else {
                    $(getContainer).find(`.fa`).removeClass(`fa-angle-up`);
                }
            });
        }

        if (this.spinners) {
            this.spinners.each(() => {
                new Swiper(`.category-swiper`, {
                    modules: [Navigation, Pagination, Scrollbar, A11y],
                    spaceBetween: 10,
                    watchSlidesProgress: true,
                    wrapperClass: `category-swiper-wrapper`,
                    breakpoints: {
                        0: {
                            slidesPerView: 1,
                            slidesPerGroup: 1,
                        },
                        480: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                            slidesPerGroup: 2,
                        },
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                            slidesPerGroup: 3,
                        },
                        1024: {
                            slidesPerView: 4,
                            spaceBetween: 20,
                            slidesPerGroup: 4,
                        },
                        1200: {
                            slidesPerView: 5,
                            spaceBetween: 20,
                            slidesPerGroup: 5,
                        },
                    },
                    navigation: {
                        nextEl: `.swiper-button-next`,
                        prevEl: `.swiper-button-prev`,
                    },
                });
            });
        }
    }

    /**
     * Hides display of error message
     * @private
     */
    private _hideError() {
        this.error.addClass(`d-none`);
        this.errorMessage.text(``);
    }

    /**
     * Shows provided error message
     * @param errorMessage
     * @private
     */
    private _showError(errorMessage: string) {
        this.error.removeClass(`d-none`);
        this.errorMessage.text(errorMessage);
    }
}
